import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RED = '#B22222';
const DARK_RED = '#8B0000';
const GOLD = '#FFD700';

/**
 * ============================================================
 * NAVBAR - do bilkul alag roop
 * ============================================================
 */
const Navbar = () => {

    const { user, token, logout } = useAuth();
    const navigate = useNavigate();

    const role = user?.role || 'USER';
    const isPoojari = role === 'POOJARI';
    const isAdmin = role === 'ADMIN' || role === 'SUPER_ADMIN';

    const handleLogout = async () => {
        await logout();
        navigate('/');
    };

    const homePath = isPoojari
        ? '/poojari-dashboard'
        : isAdmin
            ? '/admin-dashboard'
            : '/home';

    // ⚠️ Poojari ke liye "Bhadrak 758078", baaki ke liye brand

    const subtitle = isPoojari && (user?.city || user?.pincode)
        ? `${user.city || ''} ${user.pincode || ''}`.trim()
        : 'Yajman Pooja';

    // ===== LOGGED OUT =====
    if (!token) {
        return (
            <nav className="navbar navbar-expand-lg"
                style={{
                    background: 'linear-gradient(180deg, #FFFFFF, #FFF8EF)',
                    borderBottom: `1px solid ${GOLD}`
                }}>
                <div className="container">

                    <Link className="navbar-brand fw-bold"
                        to="/"
                        style={{
                            color: DARK_RED,
                            fontSize: '1.1rem'
                        }}>
                        🕉️ Yajman Pooja
                    </Link>

                    <div className="d-flex gap-2">
                        <Link className="btn btn-sm fw-bold"
                            to="/login"
                            style={{
                                border: `1px solid ${GOLD}`,
                                color: DARK_RED,
                                borderRadius: '8px',
                                fontSize: '13px'
                            }}>
                            Login
                        </Link>
                        <Link className="btn btn-sm fw-bold"
                            to="/register"
                            style={{
                                backgroundColor: RED,
                                color: GOLD,
                                borderRadius: '8px',
                                fontSize: '13px'
                            }}>
                            Register
                        </Link>
                    </div>

                </div>
            </nav>
        );
    }

    // ===== LOGGED IN =====
    return (
        <div style={{ backgroundColor: DARK_RED }}>
            <div className="container px-3">

                   <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '8px 0',
                    position: 'relative'
                }}>

                    <div style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        backgroundColor: '#A81919',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '18px',
                        flexShrink: 0
                    }}>
                        🙏
                    </div>

                    <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{
                            fontSize: '14px',
                            fontWeight: 700,
                            color: GOLD,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            Namaste, {user?.firstName || 'ji'}
                        </div>
                        <div style={{
                            fontSize: '11px',
                            color: '#FFE4B5',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}>
                            {subtitle}
                        </div>
                    </div>

                    <button
                        className="border-0"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        style={{
                            fontSize: '13px',
                            color: GOLD,
                            fontWeight: 600,
                            flexShrink: 0,
                            backgroundColor: 'transparent',
                            border: `1px solid ${GOLD}`,
                            borderRadius: '8px',
                            padding: '5px 12px',
                            whiteSpace: 'nowrap'
                        }}>
                        My Account &#9662;
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end"
                    style={{
                        borderColor: GOLD,
                        fontSize: '14px',
                        minWidth: '230px'
                    }}>

                    <li className="px-3 py-2">
                        <div style={{
                            fontSize: '13px',
                            fontWeight: 700,
                            color: DARK_RED
                        }}>
                            {user?.firstName} {user?.lastName}
                        </div>
                        <div className="text-truncate"
                            style={{ fontSize: '11px', color: '#888' }}>
                            {user?.email}
                        </div>
                    </li>

                    <li><hr className="dropdown-divider" /></li>

                    {isPoojari ? (
                        <>
                            <li>
                                <Link className="dropdown-item py-2"
                                    to="/poojari-dashboard">
                                    Dashboard
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item py-2"
                                    to="/poojari-bookings">
                                    My bookings
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item py-2"
                                    to="/poojari-profile">
                                    My profile
                                </Link>
                            </li>
                        </>
                    ) : isAdmin ? (
                        <>
                            <li>
                                <Link className="dropdown-item py-2"
                                    to="/admin-dashboard">
                                    Dashboard
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item py-2"
                                    to="/admin/poojaris">
                                    Manage poojaris
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item py-2"
                                    to="/admin/users">
                                    Manage users
                                </Link>
                            </li>
                        </>
                    ) : (
                        <>
                            <li>
                                <Link className="dropdown-item py-2"
                                    to={homePath}>
                                    Find poojari
                                </Link>
                            </li>
                            {/* ⚠️ /my-bookings pe NAHI bhej rahe - wo
                                page DEAD hai. Route to hai par sab
                                kuch Home ke tabs mein aa chuka hai.
                                state se seedha "Active" tab khulta
                                hai. */}
                            <li>
                                <Link className="dropdown-item py-2"
                                    to="/home"
                                    state={{ tab: 'active' }}>
                                    My bookings
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item py-2"
                                    to="/profile">
                                    My profile
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item py-2"
                                    to="/my-payments">
                                    My payments
                                </Link>
                            </li>
                            <li>
                                <Link className="dropdown-item py-2"
                                    to="/my-reviews">
                                    My reviews
                                </Link>
                            </li>
                        </>
                    )}

                    <li><hr className="dropdown-divider" /></li>
                    <li>
                        <button
                            className="dropdown-item py-2"
                            type="button"
                            style={{ color: '#999' }}
                            onClick={handleLogout}>
                            Logout
                        </button>
                    </li>
                </ul>
             </div>
            </div>
        </div>
    );
};

export default Navbar;